import { FormControl, InputLabel } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import { DateRangePicker } from 'react-dates';
import styled from 'styled-components/macro';

// https://github.com/airbnb/react-dates/tree/2b8089bc6ae565eea87d69880cee9b9097b04434

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './DateRangePicker.css';
import { Moment } from 'moment';
import moment from 'utils/app-moment';
interface CustomDateRangePickerProps {
  label?: string;
  value?: { startDate: Moment | null; endDate: Moment | null };
  onChange: (val: { startDate: string; endDate: string }) => any;
  disabled?: boolean;
}
const CustomDateRangePicker: React.FC<CustomDateRangePickerProps> = ({
  label,
  value,
  onChange,
  disabled,
}) => {
  const [dateRange, setDateRange] = useState<{
    startDate: Moment | null;
    endDate: Moment | null;
  }>({
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    if (value && 'startDate' in value && 'endDate' in value) {
      setDateRange(value);
    }
  }, [value]);

  const [focusedInput, setFocusedInput] = useState('startDate');
  const handleDatesChange = ({ startDate, endDate }) => {
    setDateRange({ startDate, endDate });
    console.debug(`date change: `, { startDate, endDate });
    onChange({ startDate, endDate });
  };

  const isFocus = useMemo(() => !!focusedInput, [focusedInput]);
  return (
    <SFormControl
      disabled={disabled}
      className={`${isFocus ? 'is-focus' : ''} ${
        disabled ? 'is-disabled' : ''
      }`}
    >
      {label && <SInputLabel shrink>{label}</SInputLabel>}
      <SPickerWrapper>
        <DateRangePicker
          // showDefaultInputIcon={true}
          // inputIconPosition="after"
          small
          noBorder
          startDateId={`startDate-${label}`}
          startDate={dateRange.startDate}
          endDateId={`endDate-${label}`}
          endDate={dateRange.endDate}
          onDatesChange={handleDatesChange}
          focusedInput={focusedInput}
          onFocusChange={(focusedInput) => {
            setFocusedInput(focusedInput);
            console.debug('focus changed: ', focusedInput);
          }}
          keepOpenOnDateSelect
          displayFormat="YYYY-MM-DD"
          isOutsideRange={(day) => moment(day).isAfter(moment(), 'd')}
          isDayHighlighted={(day) =>
            moment(day).isSame(moment(), 'd')
          }
          disabled={disabled}
          minimumNights={0}
          showClearDates
        />
      </SPickerWrapper>
    </SFormControl>
  );
};

export default CustomDateRangePicker;
const SFormControl = styled(FormControl)`
  &.MuiFormControl-root {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 4px;
    border: solid 1px
      ${(props) => props.theme.palette.common.borderGreyDarker};
    height: 3rem;
  }

  &.MuiFormControl-root:not(.is-disabled):hover {
    border-color: ${(props) => props.theme.palette.primary.main};
  }
  /* &.is-hovered {
    border-color: ${(props) => props.theme.palette.primary.main};
  } */
  &.is-focus {
    border-width: 2px;
    border-color: ${(props) => props.theme.palette.primary.main};
    & > .MuiFormLabel-root {
      color: ${(props) => props.theme.palette.primary.main};
    }
  }
`;
const SInputLabel = styled(InputLabel)`
  &.MuiInputLabel-shrink {
    margin-left: 5px;
  }
`;
const SPickerWrapper = styled.div`
  margin-top: 10px;
`;
